/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/mapstorybuilder.scss';

let tagMsg;

const MapStoryBuilder = ({ storyData }) => {
	const list = storyData.map((item) => {

		return (
			<div className="map-stories-entry-containers">
				<div className="map-stories-image-containers story-map-elements col-images">
					<a href={item.URL}><img src={item.Image} /></a>
				</div>
				<div className="map-stories-content-containers story-map-elements">
					<div className="map-stories-titles col-titles"><a href={item.URL}>{item.Headline}</a></div>
					<div className="map-stories-descriptions">{item.Dek}</div>
				</div>

			</div>
		);
	});

	//Hide/show headline tag based on number of items showing
    if(storyData.length == 0){
      tagMsg = ""
    }else{
    	tagMsg = "More tips and recommendations related to your search:"
    }

	return (
	<div id="story-results-container" className="content">
		<div id="story-results-label"> {tagMsg} </div>
	  	{list}
	</div>

	);
};




export default MapStoryBuilder;
